<div *ngIf="modal" class="modal">
    <div class="modal__container">
        <div class="modal__header">
            <h2 class="modal__title">Detalle Solicitud {{numeroSolicitud}}</h2>
            <a (click)="show(false)" class="btn-close"><i class="material-icons">close</i></a>
        </div>
        <div class="modal__body">
            <div class="modal__form">
                <label>Cédula de identidad</label>
                <p>{{dni}}</p>
            </div>
            <div class="modal__form">
                <label>Nombre</label>
                <p>{{detalleSolicitud?.nombres}} {{detalleSolicitud?.apellidoPaterno}} {{detalleSolicitud?.apellidoMaterno}}</p>
            </div>
            <div class="modal__form">
                <label>Número de medio de acceso</label>
                <p>{{cardSelected}}</p>
            </div>
            <div class="modal__form">
                <label>Fecha de Creación</label>
                <p>{{ fechaCreacionIso | date:'dd/MM/yyyy' }}</p>
            </div>
            <div class="modal__form">
                <label>Ejecutivo de atención</label>
                <p>{{detalleSolicitud?.nomEjeResponsable}}</p>
            </div>
            <div *ngIf="detalleSolicitud?.nomOficinaOrigen != ' '" class="modal__form">
                <label>Oficina</label>
                <p>{{detalleSolicitud?.nomOficinaOrigen}}</p>
            </div>
            <div class="modal__form">
                <label>Estado</label>

                <p>{{detalleSolicitud?.desEstado}}</p>
            </div>
            <div class="modal__form">
                <label>Tipo de Solicitud</label>
                <p>{{detalleSolicitud?.desTipoSolicitud}}</p>
            </div>
            <!--             <div class="modal__form">
                <label>Clasificación</label>
                <p>{{detalleSolicitud.solicitud.}}</p>
            </div> -->
            <div class="modal__form">
                <label>Fecha Incidente</label>
                <p>{{fecha | date:'dd/MM/yyyy HH:mm' }}</p>
            </div>
            <div class="modal__form">
                <label>Monto Solicitado</label>
                <p>{{ detalleSolicitud?.montoSolicitado / 100 }}</p>
            </div>
            <div class="modal__form">
                <label>Descripción</label>
                <p>{{detalleSolicitud?.desTipoSolicitud}}</p>
            </div>
        </div>
        <div class="modal__footer">
            <button class="btn btn-cancelar" (click)="show(false)">Cerrar</button>
        </div>
    </div>
</div>
<div class="detalle__movimiento">
    <div class="detalle__title-2">
        <h2>Solicitudes Historicas</h2>
        <p *ngIf="errorMensaje" class="alert red">{{errorMensaje}}</p>
    </div>
    <div class="movimientos movimientosComponent">
        <div class="movimientos__items">
            <div>
                <h2>N&deg; Orden </h2>
            </div>
            <div>
                <h2>Tipo</h2>
            </div>
            <div>
                <h2>Fecha</h2>
            </div>
            <div>
                <h2>Estado</h2>
            </div>
        </div>
        <ng-container *ngIf="solicitudes.length > 0; else noResult">
            <div *ngFor="let data of solicitudes" class="movimientos__items content">
                <div class="link">
                    <h2>N&deg; Orden</h2>
                    <p (click)="detalles(data.id, data.tipoSolicitud, data.fechaCreacion)">
                        {{data.id}}
                    </p>
                </div>
                <div class="date">
                    <h2>Tipo</h2>
                    <p>{{data.tipoSolicitud | titlecase}}</p>
                </div>
                <div class="body">
                    <h2>Fecha</h2>
                    <p>{{data.fechaCreacion | date:'dd/MM/yyyy HH:mm'  }}</p>
                </div>
                <div class="saldo">
                    <h2>Estado</h2>
                    <p> {{data.estado | titlecase}}</p>
                </div>
            </div>
        </ng-container>

        <ng-template #noResult>
            <div class="movimientos__items content">
                <div class="body">
                    No tiene solicitudes
                </div>
            </div>
        </ng-template>
    </div>
</div>